import { type RouteRecordRaw } from 'vue-router'

export const DashboardRouter: RouteRecordRaw[] = [
  {
    path: '/',
    component: async () => import('./Dashboard.vue'),
  },
]
